import React from "react";

// Mui
import { Backdrop } from "@mui/material";

// Jds
import { Spinner, Text } from "@jds/core";

export default function PageLoader(props) {
  return (
    <Backdrop {...props} sx={{ zIndex: 50 }}>
      <Spinner label={<Text text={props?.label} {...props.labelprops} />} />
    </Backdrop>
  );
}
